import type { ReactNode } from 'react'

interface Props {
  href: string
  children: ReactNode
  className?: string
}

export function ExtLink({ href, children, className = '' }: Props) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={`text-accent hover:underline ${className}`}
    >
      {children}
      <span aria-hidden="true" className="text-text-dim/70 text-[0.7em] ml-0.5">
        ↗
      </span>
    </a>
  )
}
